import React from "react";
import { FaSpinner } from "react-icons/fa";

const FetchingLoading = ({ label = "Loading" }) => {
  return (
    <div
      className="flex flex-col items-center justify-center py-14 px-4"
      role="status"
      aria-live="polite"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brandSoft border border-main/10 shadow-soft">
        <FaSpinner
          className="text-main text-xl animate-spin"
          aria-hidden="true"
        />
      </div>
      <span className="mt-3.5 text-sm font-semibold text-muted tracking-wide">
        {label}…
      </span>
    </div>
  );
};

export default FetchingLoading;
